import type { ExchangeRate } from '@/services/exchange/types'
import { company } from '@/config/company'
import { formatRate } from '@/utils/formatRate'
import styles from './RateTicker.module.css'

interface RateTickerProps {
  rates: ExchangeRate[]
}

export function RateTicker({ rates }: RateTickerProps) {
  if (!rates.length) return null

  const items = [...rates, ...rates]

  return (
    <div className={styles.bar} aria-label="Canlı kur şeridi">
      <div className={styles.marquee}>
        <div className={styles.track}>
          {items.map((r, i) => (
            <span key={`${r.sourceCode}-${i}`} className={styles.item}>
              <strong>{r.code}</strong>
              <span className={styles.label}>ALIŞ:</span>
              <span className={styles.box}>{formatRate(r.buy)}</span>
              <span className={styles.label}>SATIŞ:</span>
              <span className={styles.box}>{formatRate(r.sell)}</span>
            </span>
          ))}
        </div>
      </div>
      <aside className={styles.brand} aria-label="Firma ünvanı">
        {company.legalName}
      </aside>
    </div>
  )
}
